import { ContentType, Schedule } from 'hooks/queries/schedules/useAddToBrandPlanSchedule'
import { expandTopicRowsToPayload } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/CreateContentModal/utils'
import { TopicRow } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/CreateContentModal/Types'
import { ComposeRowData } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/NewPostModal/Types'
import { ContentCategory } from 'utils/brandPlans/contentCategories'
import {
  getRecommendedWordLength,
  SCRIPT_WORDS_PER_SECOND,
} from 'components/Previews/components/VideoPlayer/AudioEditorModal/utils/getRecommendedWordLength'

export const VIDEO_SCRIPT_CONTENT_CATEGORIES: ContentCategory[] = ['feed_video_post', 'short_form_video']

/** UGC script videos are fixed-length; narration target is video length minus intro/outro padding. */
export const VIDEO_SCRIPT_DURATION_SECONDS = 12
export const VIDEO_SCRIPT_RECOMMENDED_WORD_LENGTH = getRecommendedWordLength(VIDEO_SCRIPT_DURATION_SECONDS)

/** Avatar script videos target ~15s of narration with no intro/outro padding. */
export const AVATAR_SCRIPT_DURATION_SECONDS = 15
export const AVATAR_SCRIPT_RECOMMENDED_WORD_LENGTH = Math.floor(
  AVATAR_SCRIPT_DURATION_SECONDS * SCRIPT_WORDS_PER_SECOND,
)

export const isVideoScriptCategory = (category: ContentCategory) => VIDEO_SCRIPT_CONTENT_CATEGORIES.includes(category)

export type VideoScriptRequestParams = {
  brand_plan_schedule_id: number
  type: ContentType
  content_type: 'video'
  topic: string
}

export const getVideoScriptRequestParams = (
  brandPlanScheduleId: number,
  row: Pick<ComposeRowData, 'contentCategory' | 'topic' | 'tactics' | 'postType' | 'postAt' | 'mediaFileIds'>,
): VideoScriptRequestParams | null => {
  if (!isVideoScriptCategory(row.contentCategory) || !row.topic.trim()) return null

  const [payload] = expandTopicRowsToPayload([row as TopicRow])
  return {
    brand_plan_schedule_id: brandPlanScheduleId,
    type: payload.type,
    content_type: 'video',
    topic: row.topic,
  }
}

export const withVideoScriptPayload = (payload: Schedule, row: ComposeRowData): Schedule => ({
  ...payload,
  video_script: row.videoScript || undefined,
  video_caption_style: row.avatarCaptionStyle || undefined,
  video_voiceover_voice: row.videoVoiceoverVoice || undefined,
})
